module.exports = __webpack_public_path__ + "static/media/darkWorld.30704256.svg";